import { Badge, Button, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import Select from "react-select";
import BookingRequestsService from "../../../../../services/BookingService";
import { useState } from "react";
import VendorBookingService from "../../../../../services/VendorBookingService";

const ChangeStatusModal = ({ item, modal, setModal, setShouldUpdate }) => {
	const lang = useSelector((state) => state.auth.lang);
	const Auth = useSelector((state) => state.auth?.auth);
	const options = [
		{ label: "Pending", value: "pending" },
		{ label: "Processing", value: "processing" },
		{ label: "On the way", value: "on_the_way" },
		{ label: "Delivered", value: "delivered" },
		{ label: "Cancelled", value: "cancelled" },
	];
	const [status, setStatus] = useState("");
	const [note, setNote] = useState("");
	const bookingRequestsService =
		Auth?.type === "admin"
			? new BookingRequestsService()
			: new VendorBookingService();

	const changeStatus = () => {
		bookingRequestsService
			.toggleStatus(item?.id, { status: status?.value, note: note })
			.then((res) => {
				if (!!res?.status) {
					setShouldUpdate((prev) => !prev);
				}
			});
	};
	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={modal}
			onHide={() => {
				setModal();
			}}>
			<Modal.Body>
				<Row>
					<Col md={12} className="mb-2">
						<div className="d-flex justify-content-between">
							<p
								className="mb-0 text-black fw-bold"
								style={{
									fontSize: "20px",
								}}>
								{Translate[lang]?.change} {Translate[lang]?.status}
							</p>
							<Button
								variant=""
								className="close"
								style={{
									right: lang === "en" ? "0" : "auto",
									left: lang === "ar" ? "0" : "auto",
								}}
								onClick={() => {
									setModal();
								}}>
								<span style={{ fontSize: "22px" }}>&times;</span>
							</Button>
						</div>
					</Col>

					<Col md={12} className="mb-3">
						<label>{Translate[lang].status}</label>
						<Select
							value={status}
							onChange={(e) => setStatus(e)}
							options={options}
						/>
					</Col>
					<Col md={12}>
						<label className="d-block">{Translate[lang].note}</label>
						<textarea
							style={{
								width: "100%",
								border: "1px solid #dedede",
								borderRadius: "8px",
								padding: "8px",
							}}
							value={note}
							placeholder={Translate[lang].note}
							onChange={(e) => setNote(e.target.value)}
						/>
					</Col>
				</Row>
			</Modal.Body>
			<Modal.Footer>
				<Button
					variant="primary"
					type="button"
					onClick={changeStatus}
					className="w-100">
					{Translate[lang]?.save}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ChangeStatusModal;
